export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  All: 'Tất cả',
  Summary: 'Tổng hợp',
  Option: 'Tùy chọn',
  Source: 'Nguồn',
  Chapter: 'Chương',
  BudgetSubKindItem: 'Khoản',
  TemplateReport: 'Mẫu báo cáo',
  OptionsGetData: 'Tùy chọn lấy số liệu',
  FreeTemplate: 'Mẫu tự chủ (Tự động bù trừ âm dương số dư tạm ứng)',
  NotGetDataXDCB: 'Không lấy số liệu XDCB',
  PrintMonthSettlementAdjustment: 'In tháng chỉnh lý quyết toán',
  AndVoucherSettlementAdjustment: 'Bao gồm chứng từ chỉnh lý quyết toán',
  EstimateUsed: 'Dự toán đã sử dụng',
  GetWithDrawAndPayment: 'Lấy số rút thực chi và số thanh toán tạm ứng',
  GetWithDrawAndAdvance: 'Lấy số rút thực chi và rút tạm ứng',
  GetByFormulaSelfSetup: 'Lấy theo công thức tự thiết lập',
  SetupFormula: 'Thiết lập công thức',
  DisplayOption: 'Tùy chọn hiển thị',
  NextPageDown14: 'Các trang sau hạ thấp 1/4 trang',
  RowCountKBNN: 'Số dòng KBNN ghi',
  DisplayUnitInformation: 'Hiển thị thông tin đơn vị theo:',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  SelectAll: '<<Chọn tất>>',
  AddBudgetAdjustment: 'Cộng điều chỉnh kinh phí',
  OnlyAdvancePayment: 'Chỉ hiển thị số tạm ứng vào mục tạm ứng',
  BtnAccept: 'Xem báo cáo',

  ReportForm: {
    ND_CP_11_2020: 'Nghị định 11/2020/NĐ - CP',
    ND_CP_11_2020_Custom: 'Nghị định 11/2020/NĐ - CP (Mẫu tùy chỉnh)',
    TT_BTC_18_2020: 'Thông tư 18/2020/TT-BTC',
    TT_BTC_18_2020_Custom: 'Thông tư 18/2020/TT-BTC (Mẫu tùy chỉnh)',
  },
};
